<template>
  <div class="page-table person-list">
    <div class="page-search">
      <a-form :form="searchForm" @submit="handleSearch">
        <a-row type="flex" align="middle">
          <a-col :span="8">
            <a-form-item label="供应商名称" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
              <a-input v-decorator="['gysName']" placeholder="请输入关键词搜索" maxlength="50"/>
            </a-form-item>
          </a-col>
          <a-col :span="16" style="text-align:right;line-height: 39px;">
            <a-button type="primary" html-type="submit" style="margin-right: 8px;">查询</a-button>
            <a-button type="primary" @click="handleReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <!-- 新增按钮 -->
      <div style="margin-bottom: 12px; margin-top: 16px;">
        <a-button type="primary" @click="handleAdd">新增</a-button>
      </div>

      <!-- 表格 -->
      <div class="table-operator" style="padding: 0;">
        <standard-table
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :bordered="true"
        />
        <div class="pagination-wrapper">
          <a-pagination
            :current="PAGINATION.pageNum"
            :total="PAGINATION.total"
            :pageSize="PAGINATION.pageSize"
            :showTotal="total => `总共 ${total} 条数据`"
            showSizeChanger
            showQuickJumper
            @change="onPageChange"
            @showSizeChange="onPageSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './gysgl.less'
export default {
  name: 'Gysgl',
  data () {
    const columns = [
      {
        title: '序号',
        align: 'center',
        dataIndex: '_index',
        width: 60
      },
      {
        title: '供应商名称',
        align: 'center',
        dataIndex: 'gysName',
        width: 200
      },
      {
        title: '账号',
        align: 'center',
        dataIndex: 'userName',
        width: 160
      },
      {
        title: '操作',
        align: 'center',
        width: 240,
        customRender: (text, record) => {
          return (
            <div class="row-operator">
              <a href="javascript:;" onClick={() => this.handleDetail(record)}>详情</a>
              <a-divider type="vertical" />
              <a href="javascript:;" onClick={() => this.handleEdit(record)}>编辑</a>
              <a-divider type="vertical" />
              <a href="javascript:;" onClick={() => this.handleRemove(record)}>删除</a>
              <a-divider type="vertical" />
              <a href="javascript:;" onClick={() => this.handleResetPassword(record)}>重置密码</a>
            </div>
          )
        }
      }
    ]
    return {
      searchForm: this.$form.createForm(this),
      columns,
      dataSource: [],
      PAGINATION: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.fetchList(this.getFetchParams())
  },
  methods: {
    fetchList (params) {
      this.$axios.post('/api/gysgl/list.do', params).then(res => {
        console.log('供应商列表接口返回：', res)
        const list = (res.data && res.data.list) || {}
        this.dataSource = list.data || []
        const { pageNum, pageSize } = params
        this.PAGINATION = {
          total: list.totalRecords || 0,
          pageNum,
          pageSize
        }
      })
    },
    handleDetail (record) {
      this.$router.push({ path: '/gysmanagement/detail', query: { id: record.id } })
    },
    handleAdd () {
      this.$router.push({ path: '/gysmanagement/add' })
    },
    handleEdit (record) {
      this.$router.push({ path: '/gysmanagement/add', query: { id: record.id } })
    },
    handleSearch (e) {
      e.preventDefault()
      this.fetchList(this.getFetchParams({ pageNum: 1 }))
    },
    handleReset () {
      this.searchForm.resetFields()
      this.fetchList(this.getFetchParams({ pageNum: 1 }))
    },
    onPageChange (page) {
      this.fetchList(this.getFetchParams({ pageNum: page }))
    },
    onPageSizeChange (current, size) {
      this.fetchList(this.getFetchParams({ pageNum: 1, pageSize: size }))
    },
    onChange (changeParams) {
      this.fetchList(this.getFetchParams(changeParams))
    },
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = params.pageNum || 1
        params.pageSize = params.pageSize || 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      return params
    },
    handleRemove (record) {
      this.$confirm({
        title: '提示',
        content: '确定删除该供应商？',
        okType: 'danger',
        onOk: () => {
          this.removeAjax({ id: record.id })
        }
      })
    },
    removeAjax (params) {
      this.$axios.post('/api/gysgl/delete.do', params).then(res => {
        this.$message.success('删除成功！')
        this.fetchList(this.getFetchParams({ isRemove: true }))
      })
    },
    handleResetPassword (record) {
      this.$confirm({
        title: '提示',
        content: '确定将该供应商的密码重置为初始密码 Aiit#123456？',
        onOk: () => {
          this.$axios.post('/api/gysgl/resetPassword.do', { id: record.id }).then(() => {
            this.$message.success('密码已重置为 Aiit#123456')
          })
        }
      })
    }
  }
}
</script>
